/** Partner console — Payouts (Stripe Connect onboarding + status). */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

import { PartnerPageHeader } from "@/components/PartnerLayout";
import { Spinner } from "@/components/Spinner";
import {
  useConnectOnboard,
  useConnectRefresh,
  usePartnerMe,
} from "@/lib/partner";

export default function PartnerPayoutsPage() {
  const { t } = useTranslation();
  const me = usePartnerMe();
  const onboard = useConnectOnboard();
  const refresh = useConnectRefresh();

  // Returning from Stripe-hosted onboarding → re-read payout status once.
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get("connect")) {
      refresh.mutate();
      window.history.replaceState({}, "", window.location.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (me.isLoading) return <Spinner fullscreen label={t("common.loading")} />;
  if (!me.data) return null;
  const p = me.data;
  if (!p.payouts.is_payee) return <Navigate to="/partner" replace />;

  return (
    <>
      <PartnerPageHeader
        eyebrow={t("nav.partner.payouts")}
        title={t("partner.payouts.title")}
        description={t("partner.payouts.lead")}
      />

      <section className="card space-y-3">
        {p.payouts.payouts_enabled ? (
          <p className="text-sm text-nb-mint">
            ✓ {t("partner.payouts.enabledLong")}
          </p>
        ) : (
          <div className="space-y-2">
            <p className="text-sm text-nb-text-2">
              {t("partner.payouts.setupBlurb")}
            </p>
            <button
              type="button"
              className="btn-primary text-sm"
              onClick={() => onboard.mutate()}
              disabled={onboard.isPending || refresh.isPending}
            >
              {onboard.isPending
                ? t("partner.payouts.redirecting")
                : p.payouts.has_account
                  ? t("partner.payouts.continueCta")
                  : t("partner.payouts.setupCta")}
            </button>
            {refresh.isPending && (
              <span className="ml-2 text-xs text-nb-text-3">
                {t("partner.payouts.checking")}
              </span>
            )}
          </div>
        )}
      </section>
    </>
  );
}
